import React from "react";
import "../styles/Nursing.css";

export default function Nursing() {
  return (
    <div className="nursing-main">
      <div className="nursing-container">
        <h1>Nursing (GNM)</h1>
        <div className="nursing-card">
          <img src="/Nurseimage2.jpg" alt="Nursing GNM" className="nursing-img" />
          <div className="nursing-info">
            <div className="nursing-heading">Sarojini College of Nursing</div>
            <div className="nursing-inst">General Nursing and Midwifery (GNM)</div>
            <div className="nursing-desc">
              The General Nursing and Midwifery (GNM) course at Sarojini Group of Institutes is designed to prepare students for a rewarding career in healthcare. Our program combines rigorous academic learning with hands-on clinical experience, empowering graduates to excel in patient care and community health.
            </div>
            <div className="nursing-highlights">
              <h2>Key Highlights</h2>
              <ul>
                <li><b>Duration:</b> 3 Years </li>
                <li><b>Eligibility:</b> 10+2 (Any Stream)</li>
                <li><b>Affiliation:</b> Maharashtra Nursing Council, Mumbai & Indian Nursing Council, New Delhi</li>
              </ul>
            </div>
            <div className="nursing-structure">
              <h2>Course Structure</h2>
              <ul>
                <li>Fundamentals of Nursing</li>
                <li>Medical-Surgical Nursing</li>
                <li>Community Health Nursing</li>
                <li>Child Health Nursing</li>
                <li>Mental Health Nursing</li>
                <li>Midwifery & Gynecological Nursing</li>
              </ul>
            </div>
            <div className="nursing-career">
              <h2>Career Opportunities</h2>
              <p>
                Graduates can work as staff nurses, nursing supervisors, educators, and in various roles in hospitals, clinics, and community health centers. The GNM program also opens doors for higher studies and specialization.
              </p>
            </div>
            <a href="/apply?course=GNM" className="nursing-apply-btn">
              Apply for Nursing (GNM)
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}